module.exports = __webpack_public_path__ + "img/Sugeridos.bd2819e5.png";